const MuiPopover = {
  styleOverrides: {
    root: {
      zIndex: '1301 !important',
    },
  },
};

export default MuiPopover;
